import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { EmployeeService } from '@app/services/employee.service';
import { UserService } from '@app/services/user.service';
import { JobApplicationLoginModalComponent } from './job-application-login-modal/job-application-login-modal.component';
import { JobApplicationModalComponent } from './job-application-modal/job-application-modal.component';
import { JobApplicationProfileModalComponent } from './job-application-profile-modal/job-application-profile-modal.component';
import { JobApplicationVerifiedModalComponent } from './job-application-verified-modal/job-application-verified-modal.component';
import { status_code } from 'functions/src/help/status-query';

@Component({
  selector: 'app-job-application',
  templateUrl: './job-application.component.html',
  styleUrls: ['./job-application.component.css']
})
export class JobApplicationComponent {

  @Output() eventApplication = new EventEmitter<string>();

  @ViewChild('jobApplicationLoginModal') jobApplicationLoginModalComponent: JobApplicationLoginModalComponent;
  @ViewChild('jobApplicationModal') jobApplicationModalComponent: JobApplicationModalComponent;
  @ViewChild('jobApplicationProfileModal') jobApplicationProfileModalComponent: JobApplicationProfileModalComponent;
  @ViewChild('jobApplicationVerifiedModal') jobApplicationVerifiedModalComponent: JobApplicationVerifiedModalComponent;

  constructor(
    private userService: UserService,
    private employeeService: EmployeeService
  ) { }

  setJobApply(
    _idJob: number,
    jobPosition: string,
    jobTitle: string,
    jobGradeFrom: string,
    jobGradeTo: string,
    jobAddress3: Array<any>,
    jobQuestions: Array<any>,
    employerName: string,
    isCallEmployerPage: boolean
  ) {
    if (!this.userService.isEmployee()) {
      this.jobApplicationLoginModalComponent.setValues(_idJob, jobPosition, jobTitle, jobGradeFrom, jobGradeTo, isCallEmployerPage);
      return;
    }

    this.employeeService.getValidProfileApplication(this.userService.getIdEmployee(), _idJob).toPromise().then(res => {

      if (res.status_code === status_code.success) {

        if (res.employeeProfileValid === 0) {

          this.jobApplicationProfileModalComponent.setValues(_idJob);
          return;
        }

        if (res.userEmailVerified === 0) {

          this.jobApplicationVerifiedModalComponent.setValues(_idJob, jobPosition, jobTitle, jobGradeFrom, jobGradeTo);
          return;
        }

        this.jobApplicationModalComponent.setValues(
          jobAddress3,
          jobQuestions,
          employerName,
          _idJob,
          jobPosition,
          jobTitle,
          jobGradeFrom,
          jobGradeTo,
          res.employeeConditions,
          res?.employeeCriminalRecord,
          res?.employeeWwcRecord,
          res?.remainingReference,
          res?.employeeEnglishLevel,
          res?.employeeNacionality,
          res?.jobYear);
      }
    })
  }

  eventApplicationParent(event: string) {
    this.eventApplication.next(event)
  }
}
